import React from "react";
import Paragraph from "./paragraph";

const List = ({ values, ordered = false }) => (
  <Paragraph as={ordered ? "ol" : "ul"} content={values} />
);

export default List;
